import Vue from 'vue';
import Router from 'vue-router';

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
}

Vue.use(Router);

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/workbench'
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/workbench',
                    component: () => import(/* webpackChunkName: "workbench" */ '../components/page/Workbench.vue'),
                    meta: { title: '首页' }
                },
                {
                    path: '/taskManage',
                    component: () => import(/* webpackChunkName: "taskManage" */ '../components/page/task/TaskManage.vue'),
                    meta: { title: '任务管理' }
                },     
                {
                    path: '/taskCreate',
                    component: () => import(/* webpackChunkName: "taskCreate" */ '../components/page/task/TaskCreate.vue'),
                    meta: { title: '创建任务' }
                },                              
                {
                    path: '/taskEdit',
                    component: () => import(/* webpackChunkName: "taskEdit" */ '../components/page/task/TaskEdit.vue'),
                    meta: { title: '编辑任务' }
                }, 
                             
                {
                    path: '/deviceManage',
                    component: () => import(/* webpackChunkName: "deviceManage" */ '../components/page/device/DeviceManage.vue'),
                    meta: { title: '设备管理' }
                }, 
                {
                    path: '/deviceCreate',
                    component: () => import(/* webpackChunkName: "deviceCreate" */ '../components/page/device/DeviceCreate.vue'),
                    meta: { title: '增加设备' }
                },       
                {
                    path: '/deviceBatchCreate',
                    component: () => import(/* webpackChunkName: "deviceBatchCreate" */ '../components/page/device/DeviceBatchCreate.vue'),
                    meta: { title: '批量增加设备' }
                },   
                {
                    path: '/deviceEdit',
                    component: () => import(/* webpackChunkName: "deviceEdit" */ '../components/page/device/DeviceEdit.vue'),
                    meta: { title: '编辑设备' }
                },
                {
                    path: '/deviceMove',
                    component: () => import(/* webpackChunkName: "deviceMove" */ '../components/page/device/DeviceMove.vue'),
                    meta: { title: '移动设备' }
                },                
                {
                    path: '/deviceGroupCreate',
                    component: () => import(/* webpackChunkName: "deviceGroupCreate" */ '../components/page/device/DeviceGroupCreate.vue'),
                    meta: { title: '创建分组' }
                },                                                                  
                {
                    path: '/groupManage',
                    component: () => import(/* webpackChunkName: "groupManage" */ '../components/page/group/GroupManage.vue'),
                    meta: { title: '分组业务' }
                },  
                {
                    path: '/groupCreate',
                    component: () => import(/* webpackChunkName: "groupCreate" */ '../components/page/group/GroupCreate.vue'),
                    meta: { title: '创建分组' }
                },
                {
                    path: '/groupEdit',
                    component: () => import(/* webpackChunkName: "groupEdit" */ '../components/page/group/GroupEdit.vue'),
                    meta: { title: '编辑分组' }
                },                
                {
                    path: '/groupMove',
                    component: () => import(/* webpackChunkName: "groupMove" */ '../components/page/group/GroupMove.vue'),
                    meta: { title: '移动分组' }
                },             
                {
                    path: '/fileMenu',
                    component: () => import(/* webpackChunkName: "fileMenu" */ '../components/page/file/FileMenu.vue'),
                    meta: { title: '文件菜单' }
                },         
                {
                    path: '/fileMenuCreate',
                    component: () => import(/* webpackChunkName: "fileMenuCreate" */ '../components/page/file/FileMenuCreate.vue'),
                    meta: { title: '添加文件' }
                },                                                                                                
                {
                    path: '/fileMenuEdit',
                    component: () => import(/* webpackChunkName: "fileMenuEdit" */ '../components/page/file/FileMenuEdit.vue'),
                    meta: { title: '编辑文件' }
                }, 
                {
                    path: '/userManage',
                    component: () => import(/* webpackChunkName: "userManage" */ '../components/page/user/UserManage.vue'),
                    meta: { title: '用户管理' }                    
                },       
                {
                    path: '/userCreate',
                    component: () => import(/* webpackChunkName: "userCreate" */ '../components/page/user/UserCreate.vue'),
                    meta: { title: '增加用户' }                    
                },                                                        
                {
                    path: '/userEdit',
                    component: () => import(/* webpackChunkName: "userEdit" */ '../components/page/user/UserEdit.vue'),
                    meta: { title: '编辑用户' }                    
                },                                                        
                {
                    path: '/noticeManage',
                    component: () => import(/* webpackChunkName: "noticeManage" */ '../components/page/notice/NoticeManage.vue'),
                    meta: { title: '消息管理' }                    
                },       
                {
                    path: '/noticeCreate',
                    component: () => import(/* webpackChunkName: "noticeCreate" */ '../components/page/notice/NoticeCreate.vue'),
                    meta: { title: '增加消息' }                    
                },                                                        
                {
                    path: '/noticeEdit',
                    component: () => import(/* webpackChunkName: "noticeEdit" */ '../components/page/notice/NoticeEdit.vue'),
                    meta: { title: '编辑消息' }                    
                },     
                {
                    path: '/noticeList',
                    component: () => import(/* webpackChunkName: "noticeList" */ '../components/page/notice/NoticeList.vue'),
                    meta: { title: '消息列表' }                    
                },                                                                                                                                                                                                              
                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: { title: '403' }
                },

            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: { title: '登录' }
        },
            
        {
            path: '*',
            redirect: '/404'
        }
    ]
});
